import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "./PermissionMap";
import { Contact, contactFactory } from "./Contact";

export class Customer {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
    public readonly addressStreet: string,
    public readonly addressNumber: string,
    public readonly addressZip: string,
    public readonly addressCity: string,
    public readonly addressCountry: string,
    public readonly referenceNumber: string | null,
    public readonly isTenantOwner: boolean,
    public readonly contacts: Contact[],
    public readonly permissions: PermissionMap | null,
  ) {
  }
}

class CustomerFactory extends ModelFactory<Customer> {
  protected fromJson(json: any): Customer {
    return new Customer(
      json['id'],
      json['display_name'],
      json['address_street'],
      json['address_number'],
      json['address_zip'],
      json['address_city'],
      json['address_country'],
      json['reference_number'],
      json['is_tenant_owner'],

      json['contacts'] ? contactFactory.fromItemsResponse(json['contacts']) : [],
      parseItemPermissions(json['permissions']),
    );
  }
}
export const customerFactory = new CustomerFactory();
